import { Component, Vue } from 'vue-property-decorator'
import { getMarketCooperationById, getProjectAllGroupPriceListBySouCourseTypeId, getProjectAllListBySouCourseTypeId } from '@/api/market'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { souCoueTypeList } from '../new-partner/data'
import { delNullProperty } from "@/utils/index"

const sourceList = [
    {label: 'BD自开拓', value: '0'},
    {label: '市场自开拓', value: '1'},
    {label: 'KA战略合作', value: '2'},
    {label: '高校业务部门', value: '3'},
    {label: '咨询平台', value: '4'},
    {label: '咨询自渠道', value: '5'}
]
@Component({
    filters: {
        timeFilter: (val: string) => (formatDate('yyyy-MM-dd hh:mm', new Date(val))),
        projectType: (souCourseTypeIdList: number[]) => {
            let souCourseTypeName = ''
            souCoueTypeList.forEach((item) => {
                if(souCourseTypeIdList){
                    if (souCourseTypeIdList.includes(item.value)) {
                        const nameArr = souCourseTypeName.split('+')
                        // 判断当前生成的名字中有几个 +
                        if (nameArr.length === souCourseTypeIdList.length) {
                            souCourseTypeName += item.label
                        } else {
                            souCourseTypeName += item.label + '+'
                        }
                    }
                }

            })
            return souCourseTypeName
        },
        filterSource: (val: string) => {
            const item = sourceList.filter(item => item.value === val)[0]
            return item ? item.label : ''
        }
    }
})
export default class SeePartner extends Vue {
    // data
    checkedLeval = false //同步下级
    partnerName = ''
    id = 0
    operationShow = true // 操作日志显示隐藏
    data: any = {}
    dissertation_list = []
    isUpdatedData = '0'
    status = ''

    projectTypeDialogShow = false
    projectTypeDialogTitle = ''
    projectTypeTableData = []
    projectTypeTableData_ = []
    projectPriceDialogShow = false
    editProjectTypePriceDialogShow = false
    projectPricetableData = [] // 项目列表
    projectPricetableHeadData = [
        { label: '项目编号', prop: 'souCourseIndex' },
        { label: '项目名称', prop: 'souCourseName' },
        // { label: '双课题备注', prop: 'doubleSouCourseName' },
        { label: '开课时间', prop: 'date' },
        { label: '导师名字', prop: 'souTeacherName' },
        { label: '项目定价', prop: 'souCoursePrice' },
        { label: '结算价', prop: 'price' },
    ]
    projectPriceFilterObj = {
        souCourseName: '',
        schoolBeginAt: [],
        souTeacherName: '',
        souCoursePrice: '',
        page: 1,
        limit: 20,
    }
    total = 0
    souCourseTypeId = undefined
    activities =  []
    adviserList = []
    loading = false
    types = ''
    title = ''
    code = ''
    bank = ''
    account = ''
    address = ''
    phone = ''

    // created
    created() {
        const query = this.$route.query
        this.id = Number(query.id)
        this.isUpdatedData = query.type as string || '0'
        this.status = query.status as string || ''
        this.getData()
    }

    // methods
    async getData() {
        this.loading = true
        await getMarketCooperationById({id: this.id, isUpdatedData: this.isUpdatedData}).then((data: any)=>{

        this.data = data.marketCooperation
        if (this.data.marketCooperationInvoice) {
            this.types = this.data.marketCooperationInvoice.types === '0' ? '增值税专用发票' : this.data.marketCooperationInvoice.types === '1' ? '增值税普通发票' : '-'
            this.title = this.data.marketCooperationInvoice.title
            this.code = this.data.marketCooperationInvoice.code
            this.code = this.data.marketCooperationInvoice.code
            this.bank = this.data.marketCooperationInvoice.bank
            this.account = this.data.marketCooperationInvoice.account
            this.address = this.data.marketCooperationInvoice.address
            this.phone = this.data.marketCooperationInvoice.phone
        }
        if (this.data.isAsync == '0') {
            this.checkedLeval = false
        }
        if (this.data.isAsync == '1') {
            this.checkedLeval = true
        }

        this.dissertation_list = this.data.marketCooperationProjectDissertationCommissionList
        this.dissertation_list.forEach(item => {
            if (item.commissionType == '') {
                return item.commissionType = '2'
            }
        })
        this.adviserList = this.data.marketCooperationAdviserList

        this.partnerName = this.data.name
        this.data.marketCooperationCommissionList.forEach(item => {
            item.souCourseTypeIdList && (item.souCourseTypeIdList = item.souCourseTypeIdList.map(id => Number(id)))
        })
        //    审批流程
        this.activities = data.marketCooperation.messageReviewList
        this.loading = false

        }).catch(()=>{
            this.loading = false
        })
    }
    handleBtn(id: number) {
        return menuBtn(id)
    }

    async openProjectTypePriceDialog(souCourseTypeIdList: number[], item) {
        let projectAllGroupPriceList = item.projectAllGroupPriceList || []
        this.projectTypeDialogTitle = this.getMultipleSouCourseTypeName(souCourseTypeIdList)
        this.souCourseTypeId = souCourseTypeIdList
        if (projectAllGroupPriceList.length === 0) {
            const data = await getProjectAllGroupPriceListBySouCourseTypeId({ id: this.id + '', souCourseTypeIdList: souCourseTypeIdList }) as unknown as { projectAllGroupPriceList: any[] }
            projectAllGroupPriceList = data.projectAllGroupPriceList
        }
        this.projectTypeTableData = projectAllGroupPriceList.filter(item => !item.isSetting)
        this.projectTypeTableData_ = projectAllGroupPriceList.filter(item => item.isSetting)
        this.projectTypeDialogShow = true
    }

    async editProjectTypePriceDialogShowChange(type: number) {
        if (type === 1) {
            this.getProjectAllListBySouCourseTypeId()
            this.projectTypeDialogShow = false
            this.projectPriceDialogShow = true
        }
        if (type === 2) {
            this.projectTypeDialogShow = true
            this.projectPriceDialogShow = false
        }
    }

    handleSizeChange(limit: number) {
        this.projectPriceFilterObj.limit = limit
        this.getProjectAllListBySouCourseTypeId()
    }

    handleCurrentChange(page) {
        this.projectPriceFilterObj.page = page
        this.getProjectAllListBySouCourseTypeId()
    }

    async getProjectAllListBySouCourseTypeId() {
        const obj = {}
        for (const key in this.projectPriceFilterObj) {
            obj[key] = this.projectPriceFilterObj[key]
        }
        if (this.projectPriceFilterObj.schoolBeginAt.length > 1 && Array.isArray(this.projectPriceFilterObj.schoolBeginAt)) {
            obj['schoolBeginAt'] = formatDate('yyyy-MM-dd', new Date(this.projectPriceFilterObj.schoolBeginAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.projectPriceFilterObj.schoolBeginAt[1]))
        } else {
            obj['schoolBeginAt'] = ''
        }
        const { allNum, projectAllList } = await getProjectAllListBySouCourseTypeId(delNullProperty({
            ...obj,
            souCourseTypeIdList: this.souCourseTypeId,
            projectAllGroupPriceList: [...this.projectTypeTableData, ...this.projectTypeTableData_]
        })) as unknown as { allNum: number; projectAllList: any[] }
        this.total = allNum
        this.projectPricetableData = projectAllList
    }

    // 生成 souCourseTypeName
    getMultipleSouCourseTypeName(souCourseTypeIdList: number[]): string {
        let souCourseTypeName = ''
        souCoueTypeList.forEach((item) => {
            if (souCourseTypeIdList.includes(item.value)) {
                const nameArr = souCourseTypeName.split('+')
                // 判断当前生成的名字中有几个 +
                if (nameArr.length === souCourseTypeIdList.length) {
                    souCourseTypeName += item.label
                } else {
                    souCourseTypeName += item.label + '+'
                }
            }
        })
        return souCourseTypeName
    }

    previewContractUrl() {
        window.open(this.data.financeContractUrl, 'blank')
    }
}
